import Icon from '@components/icon';
import cn from 'clsx';
import { observer } from 'mobx-react-lite';

import { etrnReadyLanding } from 'constants/pages';
import { useStore } from 'hooks/useStore';
import { interpolate } from 'utils/string/format';

import { EtrnIcon } from './EtrnIcon';

import css from './EtrnBanner.module.css';

const EtrnBanner = () => {
  const { app, etrnPromo } = useStore();

  if (!etrnPromo.isBannerVisible) return null;

  return (
    <div className={css.banner}>
      <div className={css.content}>
        <div className={css.iconContainer}>
          <EtrnIcon />
        </div>

        <div className={css.textContainer}>
          <p className={cn('glz-p glz-is-size-3 glz-is-bold', css.text)}>{app.i18n.etrnBanner.title}</p>
          <p className={cn('glz-p glz-is-size-3', css.text)}>{app.i18n.etrnBanner.description}</p>
        </div>
      </div>

      <div className={css.actions}>
        <a
          className="glz-button glz-is-small glz-is-success glz-is-outlined"
          href={interpolate(etrnReadyLanding, { env: app.env })}
          rel="noopener noreferrer"
          target="_blank"
        >
          {app.i18n.etrnBanner.button}
        </a>

        <button className={css.closeButton} type="button" onClick={etrnPromo.closeBanner}>
          <Icon name="ic_close-out" size="s" />
        </button>
      </div>
    </div>
  );
};

const connected = observer(EtrnBanner);

export { connected as EtrnBanner };
